<script setup>
import { computed, watch} from 'vue';
import PFBaseModal from "@/components/common/modal/PFBaseModal.vue";
import AcceptIcon from '../common/base/AcceptIcon.vue';
import { useModalProvider } from "@/composables/useModalProvider";
import { useStore } from 'vuex';
import { openComponent } from '../../plugins/profile/progressCompenentPlugin';  

const { openModal, isModalOpen, closeModal } = useModalProvider(); 

const store = useStore(); 

const showModal = computed(() => store.state.partnerProfile.showProgressModal);
const profileProgressData = computed(() => store.state.partnerProfile.profileProgressData);
const errorFields = computed(() => store.state.partnerProfile.errorFields);
const progressPercentage = computed(() => store.state.partnerProfile.profileProgressPercentage);


watch(showModal, (newVal) => {
  newVal ? openModal() : closeModal();  
});

watch(isModalOpen, (newVal) =>  {
  if (!newVal) {
    store.commit('partnerProfile/changeShowProgressModal', newVal);
  } 
})

</script> 

<template>
  <PFBaseModal v-if="isModalOpen" :modalHeaderText="$t('progress.modal.title')">
    <div class="body-s-size mb-6">
      {{ $t('progress.modal.text') }}
    </div>
    <div class="mb-6">
      <div class="!mb-2 eyebrow-m">
        {{ $tc('progress.modal.next', progressPercentage == 90 ? 1 : 2) }}
      </div>
      <div
          v-for="(step, idx) in profileProgressData"
          :key="step.info + idx"
        >        
        <div v-if="!step.complete" class="mb-2">
          <div
            @click="openComponent(step); closeModal();"
            class="flex"
          >
            <udex-link 
              icon="slim-arrow-right" 
              accessibleRole="Link" 
              accessibleName="View profile not completed step"
              icon-placement="End"
            >
              <span class="mx-2">&#8226;</span> 
              {{ $t(`progress-bar-next-step-text[${idx}]`) }}
            </udex-link>
          </div>
        </div>
      </div>
    </div>
    <div class="eyebrow-m !mb-2">
      {{ $t('progress.modal.completed') }}
    </div>
    <div
      v-if="errorFields && errorFields.length === 0"
      class="gap-2 flex py-1 mb-1"
    >
      <AcceptIcon width="16" height="24" variant="gray" />
      <div class="inline h-fit body-s-size step"> 
        {{ $t('progress.modal.mantatory.filled') }}
      </div>
    </div>
    <div
      v-for="(step, idx) in profileProgressData"
      :key="step.info + idx"
    >
      <div v-if="step.complete" class="py-1 mb-1">
        <div class="gap-2 flex">
          <AcceptIcon width="16" height="24" variant="gray" />
          <div class="inline h-fit body-s-size step">
            {{ $t(`progress-bar-next-step-text[${idx}]`) }}
          </div>
        </div>
      </div>
    </div>
  </PFBaseModal>
</template>